module.exports = __webpack_public_path__ + "img/vip.0a623af9.svg";